module.exports = __webpack_public_path__ + "static/media/599.767(20).8adf73ed.pdf";